/**
 * CSV取り込みタスク
 */
import Vue from 'vue'
import * as httpConst from '../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/csv_import_tasks`

const csv_import_task = {
  namespaced: true,
  actions: {
    index ({ dispatch, commit, state }, { type, page }) {
      const params = { type: type, page: page }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}

export default csv_import_task

